import { api } from "@/builders/axios";
import { Guardian } from "@/builders/types/guardians";
import { activate_or_deactivate } from "./activate-deactivate";

export interface GuardiansProps {
  first_name: string;
  last_name: string;
  other_names: string;
  phone_number: string;
  email: string;
}

const get = function (username: string) {
  return api.get<Guardian>(`guardians/${username}`);
};

const put = function (username: string, data: Guardian) {
  return api.put(`/guardians/${username}`, data);
};

const patch = function (username: string, data: Partial<Guardian>) {
  return api.patch(`/guardians/${username}`, data);
};

const del = function (username: string) {
  return api.delete(`/guardians/${username}`);
};

export const username = {
  get,
  put,
  patch,
  del,
  activate_or_deactivate,
};
